import {afterRenderEffect, ChangeDetectionStrategy, Component, ElementRef, input, InputSignal, model, ModelSignal, output, OutputEmitterRef, viewChild} from '@angular/core';
import {VirtualScrollListItemIconComponent} from '../../virtual-scroll-list/virtual-scroll-list-item-icon/virtual-scroll-list-item-icon.component';
import {IconComponent} from '../../icon/icon.component';
import {ImageContext} from '../../../models/image-context.model';
import {ICONS} from '../../../constants/icons/icons.constants';
import {AppIconSizeEnum} from '../../../enums/app-icon-size.enum';
import {Icon} from '../../../types/icons/icon.type';
import {LoadingSpinnerComponent} from '../../loading-spinner/loading-spinner.component';
import {DefaultIcon} from '../../../types/icons/default-icon.type';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-selection-form-item',
    styleUrl: 'selection-form-item.component.css',
    imports: [
        VirtualScrollListItemIconComponent,
        IconComponent,
        LoadingSpinnerComponent
    ],
    templateUrl: './selection-form-item.component.html',
    host: {
        '[attr.data-qa]': 'this.qaTag()',
        '[class.checked]': 'this.isHidingSelectionBoxes() && this.checked()',
    },
})
export class SelectionFormItemComponent {
    public qaTag: InputSignal<string> = input.required<string>();
    public id: InputSignal<string> = input.required<string>();
    public name: InputSignal<string> = input<string>('option');
    public checked: ModelSignal<boolean> = model<boolean>(false);
    public disabled: ModelSignal<boolean> = model<boolean>(false);
    public autoFocus: InputSignal<boolean> = input<boolean>(false);
    public isMultiSelect: InputSignal<boolean | undefined> = input<boolean | undefined>();
    public isHidingSelectionBoxes: InputSignal<boolean> = input<boolean>(false);
    public imageUrl: InputSignal<ImageContext | undefined> = input<ImageContext>();
    public defaultIcon: InputSignal<DefaultIcon> = input<DefaultIcon>(ICONS.DOCUMENT);
    public svgIcon: InputSignal<Icon | undefined> = input<Icon>();
    public label: InputSignal<string | undefined> = input<string | undefined>();
    public changed: OutputEmitterRef<boolean> = output();
    public isLoading: InputSignal<boolean> = input<boolean>(false);
    protected readonly AppIconSize = AppIconSizeEnum;
    protected readonly ICONS = ICONS;
    private readonly inputElement = viewChild<ElementRef<HTMLInputElement>>('inputElement');
    private hasAutoFocused: boolean = false;

    public constructor() {
        // Runs after the DOM has been written, so a hosting dialog has already finished its own focusing steps (showModal focuses the first focusable element).
        afterRenderEffect(() => {
            const inputElement = this.inputElement()?.nativeElement;
            if (this.hasAutoFocused || !inputElement || !this.autoFocus() || !this.checked()) {
                return;
            }
            this.hasAutoFocused = true;
            inputElement.focus();
        });
    }

    protected onChange(isChecked: boolean): void {
        this.checked.set(isChecked);
        this.changed.emit(isChecked);
    }
}
